import React from "react";
import movAvg1 from '../Utils/movAvg.jpg';
import macd12 from '../Utils/mcad12.png';
import macd22 from '../Utils/mcad22.png';

const Macd = () => {
  return (
    <div style={{ backgroundColor: "#E5E7EB" }}>
      <div class="container">
        <div class="article-header text-center">
          <h1 class="article-title">
            MACD (Moving Average Convergence Divergence)
          </h1>
          <p class="article-meta">MACD</p>
        </div>
        <div>
          <img
            src={movAvg1}
            alt="img"
            width="100%"
            height="550vp"
          />
        </div>
        <div class="article-content">
          <h2 class="article-section-title">Introduction</h2>
          <p>
            The Moving Average Convergence Divergence (MACD) is a popular
            technical indicator used in trading to identify trends, momentum,
            and potential reversals. It is derived from moving averages and
            combines aspects of trend-following and momentum analysis. Here's an
            in-depth look at the MACD <br />
          </p>
          <img src={macd12} alt="types of avg img" width="80%" />
          <img src={macd22} alt="types of avg img" width="80%" />
          {/* <img src="./images/advLim.png" alt="types of avg img" width="80%" /> */}
        </div>
      </div>
    </div>
  );
};

export default Macd;
